var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthenticationService } from '@app/core';
import { BalanceService, CurrencyType } from '@app/core/balance.service';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder } from '@angular/forms';
import * as QRCode from 'qrcode';
import { DomSanitizer } from '@angular/platform-browser';
import { DepositService } from '@app/core/account/deposit.service';
var DepositModal2Component = /** @class */ (function () {
    function DepositModal2Component(auth, balance, depositService, formBuilder, sanitizer) {
        this.auth = auth;
        this.balance = balance;
        this.depositService = depositService;
        this.formBuilder = formBuilder;
        this.sanitizer = sanitizer;
        this.currency = this.balance
            .getCurrency()
            .toString()
            .toUpperCase();
        this.minAmount = 0;
        this.maxAmount = 0;
        this.feeAmount = 0;
        this.subs = new Subscription();
    }
    DepositModal2Component.prototype.ngOnInit = function () {
        var _this = this;
        this.createForm();
        this.getWalletData();
        this.subs.add(this.form.get('currency').valueChanges.subscribe(function (value) {
            _this.currency = value.toString().toUpperCase();
            _this.getWalletData();
        }));
    };
    DepositModal2Component.prototype.ngAfterViewInit = function () { };
    DepositModal2Component.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
        if (this.loadAddressData) {
            this.loadAddressData.unsubscribe();
        }
    };
    DepositModal2Component.prototype.getWalletData = function () {
        var _this = this;
        if (this.loadAddressData) {
            this.loadAddressData.unsubscribe();
        }
        this.walletAddress = null;
        this.loadAddressData = this.depositService.getWallet(this.currency.toLowerCase()).subscribe(function (wallet) {
            _this.walletAddress = wallet.address || null;
            _this.minAmount = wallet.minAmount;
            _this.maxAmount = wallet.maxAmount;
            _this.feeAmount = wallet.fee;
            _this.generateQrImages();
        });
    };
    DepositModal2Component.prototype.trackDepositClose = function () {
        // if (this.isOnboarding) {
        //   amplitude.getInstance().logEvent('Onboarding - Close');
        // } else {
        //   amplitude.getInstance().logEvent('Deposit - Close');
        // }
    };
    DepositModal2Component.prototype.toQrCodeDataUrl = function (value, _a) {
        var _this = this;
        var margin = _a.margin, scale = _a.scale, width = _a.width, colorDark = _a.colorDark, colorLight = _a.colorLight, version = _a.version, errorCorrectionLevel = _a.errorCorrectionLevel;
        return new Promise(function (resolve, reject) {
            QRCode.toDataURL(value, {
                version: version || '',
                errorCorrectionLevel: errorCorrectionLevel || 'M',
                margin: margin || 4,
                scale: scale || 4,
                width: width || 10,
                color: {
                    dark: colorDark || '#000000',
                    light: colorLight || '#ffffff',
                },
            }, function (err, url) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(_this.sanitizer.bypassSecurityTrustResourceUrl(url));
                }
            });
        });
    };
    DepositModal2Component.prototype.generateQrImages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, schema, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = null;
                        if (this.walletAddress) {
                            schema = this.appSchemas(this.currency);
                            if (schema) {
                                url = schema + ":" + this.walletAddress;
                            }
                        }
                        _a = this;
                        return [4 /*yield*/, this.toQrCodeDataUrl(url || this.walletAddress, { margin: 2 })];
                    case 1:
                        _a.qrLargeUrl = _b.sent();
                        this.appUrl = url ? this.sanitizer.bypassSecurityTrustUrl(url) : null;
                        return [2 /*return*/];
                }
            });
        });
    };
    DepositModal2Component.prototype.createForm = function () {
        this.form = this.formBuilder.group({
            currency: this.balance.getCurrency(),
        });
    };
    DepositModal2Component.prototype.appSchemas = function (currency) {
        var schemas = {
            btc: 'bitcoin',
            eth: 'ethereum',
            ltc: 'litecoin',
            edg: 'ethereum',
            dai: 'ethereum',
        };
        if (schemas.hasOwnProperty(currency.toLowerCase())) {
            return schemas[currency.toLowerCase()];
        }
        return null;
    };
    DepositModal2Component.prototype.isFiat = function (currency) {
        return [CurrencyType.EUR, CurrencyType.USD, CurrencyType.USDT20, CurrencyType.DAI].includes(currency.toLowerCase());
    };
    return DepositModal2Component;
}());
export { DepositModal2Component };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/deposit-modal-2.component.ts.pre-build-optimizer.js